<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'acquisti.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="save" class="close" (click)="save()" aria-label="Close">
      <span aria-hidden="true"><i class="fas fa-save"></i></span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}" >
  <div [ngClass]="{'card-body': !isModal}">

    <div class="row">
      <div class="col-lg-4" >
        <label class="mb-0 text-dark">Seleziona il Prodotto</label>
        <ng-multiselect-dropdown
          [settings]="dropdownSettings"
          [disabled]="!permission.HasCapacity(['gestione-acquisti']) || ProdottoBrandizzato?.id ||  !this.fornitore?.id "
          [placeholder]="'Seleziona il Prodotto'"
          name="categorie"
          [data]="prodotti"
          [(ngModel)]="prodottiSelezionati"
          (onFilterChange)="filtroProdotti($event)"
          (ngModelChange)="ProdottoSelected()">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-lg-4" *ngIf="ListaProdottiBrandizzati?.length > 0 || ProdottoBrandizzato">
        <label class="mb-0 text-dark">Seleziona il Brand</label>
        <ng-multiselect-dropdown
          [settings]="prodottoBrandizzatoDropdownSettings"
          [disabled]="!permission.HasCapacity(['gestione-acquisti']) || !this.fornitore?.id "
          [placeholder]="'Seleziona il brand'"
          [data]="ListaProdottiBrandizzati"
          [(ngModel)]="ProdottoBrandizzato"
          (ngModelChange)="ProdottoBrandizzatoSelected()">
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3" *ngIf="!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideBrand']">
        <label class="mb-0 text-dark"  >Brand</label>
        <input type="text" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="VoceAcquisto.brand">
      </div>
      <div class="col-lg-1" *ngIf="!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideBrand']">
        <label class="mb-0 text-dark">Brandizzato</label>
        <input type="checkbox" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="VoceAcquisto.brandizzato">
      </div>
      <div class="col-lg-4" *ngIf="prodottoListino">
        <label class="mb-0 text-dark">Prezzo</label>
        <input readonly type="text" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])"  class="form-control" [(ngModel)]="VoceAcquisto.prezzo">
      </div>
      <div class="col-lg-4">
        <label class="mb-0 text-dark">Quantita</label>
        <input type="number" min="0" step="1" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="VoceAcquisto.quantita">
      </div>
      <div class="col-lg-4">
        <label class="mb-0 text-dark">Code30</label>
        <input type="text" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="VoceAcquisto.code30">
      </div>
      <div class="col-lg-4" *ngIf="prodottoListino">
        <label class="mb-0 text-dark">Prezzo con aggiunte</label>
        <input readonly type="text" [readOnly]="true" class="form-control" [ngModel]="getprezzoComplessivo() | number: '1.2-2'">
      </div>
      <div class="col-lg-4" >
        <label class="mb-0 text-dark">Voce extra</label>
        <input type="text" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" class="form-control" [(ngModel)]="VoceAcquisto.aggiunta">
      </div>
      <div class="col-lg-2">
        <label class="mb-0 text-dark">prezzo extra</label>
        <input  [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" type="number" class="form-control" [(ngModel)]="VoceAcquisto.aggiuntaPrezzo">
      </div>
    </div>
    <div class="card m-t-40" *ngIf="(!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideAggiunte'] || !this.environment['AcquistiAddOn']['hideStock'])" >
      <ul ngbNav #nav="ngbNav" [activeId]="VoceAcquisto?.id ? 'stockprod':'aggiunte'" class="nav-tabs">
        <li ngbNavItem="aggiunte" *ngIf="(!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideAggiunte'])">
          <a ngbNavLink> {{'acquisti.aggiunte' | translate}} </a>
          <ng-template ngbNavContent>
            <div class="row m-t-40">
              <div class="col-lg-4" *ngFor="let aggiunta of prodottoListino?.aggiunte | myfilter: permission.HasCapacity(['gestione-acquisti'])">
                <div class="card border-warning border-bottom border-top border-left border-right " >
                  <div class="card-body">
                    <div style="float:left; width: 10%">
                      <input type="checkbox" [readOnly]="!permission.HasCapacity(['gestione-acquisti'])" [(ngModel)]="aggiunta.selected" name="aggiunte">
                    </div>
                    <div style="float:right;width: 10%">
                      <label class="mb-0 text-dark">{{aggiunta.prezzo | number: '1.2-2'}}€</label>
                    </div>
                    <div style="float:right;width: 76%">
                      <label class="mb-0 text-dark">{{aggiunta.nome}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
        <li ngbNavItem="stockprod" *ngIf="VoceAcquisto?.id && (!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideStock'])">
          <a ngbNavLink> {{'acquisti.stock-produzioni' | translate}} </a>
          <ng-template ngbNavContent>
            <div class="row m-t-40">
              <div class="col-lg-6" >
                <div class="d-md-flex align-items-center bg-white p-3">
                    <span class="d-flex align-items-center p-2 ">
                    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'stock.title' | translate}}:</h5>
                    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{VoceAcquisto?.produzioneObject?.length}}</span>
                    </span>
                  <div class="ml-auto mt-3 mt-md-0">
                    <button *ngIf="permission.isPermitted('gestione-acquisti')" (click)='AddStock()' type="button" class="btn btn-cyan rounded-pill py-2" ><i
                      class="fas fa-plus  font-14 mr-1 text-white"></i>
                      <span class="ml-1 text-white font-weight-bold">{{'stock.add' | translate}}</span>
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
                    <thead>
                    <tr>
                      <th scope="col">{{'stock.data' | translate}}</th>
                      <th scope="col">{{'qty' | translate}}</th>
                      <th scope="col" *ngIf="permission.isPermitted('gestione-acquisti') || permission.isOperativeRoles['F']">{{'stock.azioni' | translate}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of VoceAcquisto?.stockObject">
                      <td class="align-middle">
                        <span class="font-14" *ngIf="!item.modifica">{{ item.data | date: 'dd/MM/yyyy'}}</span>
                        <span *ngIf="item.modifica">
                          <input [(ngModel)]="item.data" type="date" class="form-control">
                        </span>
                      </td>
                      <td >
                        <span class="font-14" *ngIf="!item.modifica">{{item.quantita}}</span>
                        <span *ngIf="item.modifica">
                          <input [(ngModel)]="item.quantita" min="0" type="number" class="form-control">
                        </span>
                      </td>
                      <td class="align-middle">
                        <a
                          href="javascript:void(0)"
                          [ngbTooltip] ="item.modifica ? ('inline.save'|translate) : ('inline.edit'|translate)"
                          class="link font-16 text-info font-medium mr-2"
                          (click)='EditStock(item)'>
                          <i class="fas" [ngClass]="{'fa-pencil-alt': !item.modifica, 'fa-check': item.modifica}"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          [ngbTooltip] ="item.modifica ? ('inline.cancel'|translate) : ('inline.delete'|translate)"
                          class="link font-16 text-danger font-medium mr-2"
                          (click)='DeleteStock(item)'>
                          <i class="fas" [ngClass]="{'fa-trash-alt': !item.modifica, 'fa-times': item.modifica}"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-lg-6" >
                <div class="d-md-flex align-items-center bg-white p-3">
                    <span class="d-flex align-items-center p-2 ">
                    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'produzione.title' | translate}}:</h5>
                    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{VoceAcquisto?.produzioneObject?.length}}</span>
                    </span>
                  <div class="ml-auto mt-3 mt-md-0">
                    <button *ngIf="permission.isPermitted('gestione-acquisti')" (click)='AddProduzione()' type="button" class="btn btn-cyan rounded-pill py-2" ><i
                      class="fas fa-plus  font-14 mr-1 text-white"></i>
                      <span class="ml-1 text-white font-weight-bold">{{'produzione.add' | translate}}</span>
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
                    <thead>
                    <tr>
                      <th scope="col">{{'produzione.data' | translate}}</th>
                      <th scope="col">{{'produzione.stock' | translate}}</th>
                      <th scope="col">{{'Disponibile il' | translate}}</th>
                      <th scope="col" *ngIf="permission.isPermitted('gestione-acquisti') || permission.isOperativeRoles['F']">{{'produzione.azioni' | translate}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of VoceAcquisto?.produzioneObject">
                      <td class="align-middle" >
                        <span class="font-14" *ngIf="!item.modifica">{{ item.data | date: 'dd/MM/yyyy'}}</span>
                        <span *ngIf="item.modifica">
                          <input [(ngModel)]="item.data" type="date" class="form-control">
                        </span>
                      </td>
                      <td>
                        <span class="font-14" *ngIf="!item.modifica">{{item.quantita}}</span>
                        <span *ngIf="item.modifica">
                          <input [(ngModel)]="item.quantita" min="0" type="number" class="form-control">
                        </span>
                      </td>
                      <td class="align-middle" >
                        <span class="font-14" *ngIf="!item.modifica">{{ item.data_disp | date: 'dd/MM/yyyy'}}</span>
                        <span *ngIf="item.modifica">
                          <input [(ngModel)]="item.data_disp" type="date" class="form-control">
                        </span>
                      </td>
                      <td class="align-middle">
                        <a
                          href="javascript:void(0)"
                          [ngbTooltip] ="item.modifica ? ('inline.save'|translate) : ('inline.edit'|translate)"
                          class="link font-16 text-info font-medium mr-2"
                          (click)='EditProduzione(item)'>
                          <i class="fas" [ngClass]="{'fa-pencil-alt': !item.modifica, 'fa-check': item.modifica}"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          [ngbTooltip] ="item.modifica ? ('inline.cancel'|translate) : ('inline.delete'|translate)"
                          class="link font-16 text-danger font-medium mr-2"
                          (click)='DeleteProduzione(item)'>
                          <i class="fas" [ngClass]="{'fa-trash-alt': !item.modifica, 'fa-times': item.modifica}"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> {{'acquisti.salva' | translate}} </span>
  </button>
</div>
